// extracted by mini-css-extract-plugin
export default {"wrapper":"MuiTable_wrapper__wfVjU","paginationWrapper":"MuiTable_paginationWrapper__iujbl","pageNumbers":"MuiTable_pageNumbers__T+3fQ","emptyTable":"MuiTable_emptyTable__32ErT"};